export const SELECT_LANGUAGE = 'SELECT_LANGUAGE'
export const SET_DATA = 'SET_DATA'
export const SET_DATA_VALUES = 'SET_DATA_VALUES'
export const SAVE_ALL = 'SAVE_ALL'
export const HAS_CHANGES = 'HAS_CHANGES'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'
export const SET_NEW_LANGUAGE = 'SET_NEW_LANGUAGE'
export const SET_SELECT_LANGUAGES = 'SET_SELECT_LANGUAGES'
export const SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE'
export const SET_LANGUAGE_CATEGORIES = 'SET_LANGUAGE_CATEGORIES'
export const CHANGE_SELECTED_LANGAUGE_NAME = 'CHANGE_SELECTED_LANGAUGE_NAME'
export const CHANGE_LANGUAGE_NAME_BUTTON = 'CHANGE_LANGUAGE_NAME_BUTTON'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SELECT_DEFAULT_LANGUAGE = 'SELECT_DEFAULT_LANGUAGE'
export const TOGGLE_LABEL_OVERLAY = 'TOGGLE_LABEL_OVERLAY'
export const SET_NEW_LABEL = 'SET_NEW_LABEL'
export const SET_NEW_LABEL_VALUE = 'SET_NEW_LABEL_VALUE'
export const SET_NEW_LABEL_KEY = 'SET_NEW_LABEL_KEY'
export const SET_LABEL_CATEGORY = 'SET_LABEL_CATEGORY'
export const SET_SYSTEM_DEFAULT_LANGUAGE = 'SET_SYSTEM_DEFAULT_LANGUAGE'
export const SET_CHANGED_DATA_VALUES = 'SET_CHANGED_DATA_VALUES'
